import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  footer: {
    border: `1px solid ${token.lightGrey.lightGrey2}`,
    display: 'flex',
    justifyContent: 'flex-end',
    bottom: 0,
    top: '100%',
    position: 'sticky',
    width: '100%'
  }
}))
